import React, { useState } from "react";
import { ChevronsUpDown, Check } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import {
  Command,
  CommandEmpty,
  CommandGroup,
  CommandInput,
  CommandItem,
  CommandList,
} from "@/components/ui/command";
import { COUNTRIES } from "@/lib/countries";

export const CountrySelect = ({ value, onChange, testid = "country-select" }) => {
  const [open, setOpen] = useState(false);
  const selected = COUNTRIES.find((c) => c.name === value);

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button
          type="button"
          data-testid={testid}
          className="flex h-11 w-full items-center justify-between rounded-lg border border-slate-200 bg-white px-3.5 text-sm outline-none transition-colors hover:border-[#CBD5E1] focus:border-[#5C9873] focus:ring-2 focus:ring-[#5C9873]/15"
        >
          {selected ? (
            <span className="flex items-center gap-2 text-[#17201A]">
              <span className="text-base">{selected.flag}</span> {selected.name}
            </span>
          ) : (
            <span className="text-slate-400">Sélectionnez un pays</span>
          )}
          <ChevronsUpDown size={15} className="text-slate-400" />
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-[--radix-popover-trigger-width] p-0" align="start">
        <Command>
          <CommandInput placeholder="Rechercher un pays…" data-testid="country-search" />
          <CommandList>
            <CommandEmpty>Aucun pays trouvé.</CommandEmpty>
            <CommandGroup>
              {COUNTRIES.map((c) => (
                <CommandItem
                  key={c.name}
                  value={c.name}
                  data-testid={`country-option-${c.name}`}
                  onSelect={() => {
                    onChange(c.name, c.code);
                    setOpen(false);
                  }}
                  className="flex items-center gap-2"
                >
                  <span className="text-base">{c.flag}</span>
                  <span className="flex-1">{c.name}</span>
                  {value === c.name && <Check size={15} className="text-[#3E7256]" />}
                </CommandItem>
              ))}
            </CommandGroup>
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
};
